import { Check, DirectionsCar } from "@mui/icons-material";
import { Grid2 } from "@mui/material";
import { t } from "i18next";
import React, { type FormEvent, useState } from "react";
import { useFormContext } from "react-hook-form";
import ButtonComponent from "../../../../../components/ButtonComponent";
import ChipListComponent from "../../../../../components/ChipListComponent";
import TextFieldComponent from "../../../../../components/TextFieldComponent";

interface CarPlateProps {
	disabled?: boolean;
}

const CarPlate = ({ disabled }: CarPlateProps) => {
	const { watch, getValues, setValue } = useFormContext<any>();
	const [newCarPlate, setNewCarPlate] = useState<string>("");

	const onSubmitPlate = (event: FormEvent) => {
		event.preventDefault();
		const carPlates = getValues("carPlates");
		if (!carPlates) {
			setValue("carPlates", [newCarPlate.toUpperCase()]);
			return;
		}
		if (
			newCarPlate.length > 0 &&
			!carPlates.includes(newCarPlate.toUpperCase())
		) {
			setValue("carPlates", [...carPlates, newCarPlate.toUpperCase()]);
		}
		setNewCarPlate("");
	};

	watch("carPlates");

	const onDelete = (index: number) => {
		// setValue(
		//   'carPlates',
		//   getValues('carPlates')?.filter((_, i) => i !== index),
		// );
	};
	return (
		<>
			<form style={{ display: "flex" }} onSubmit={onSubmitPlate}>
				<TextFieldComponent
					label={t("recognitionPage.modalEditFace.plateVehicle")}
					value={newCarPlate}
					sx={{
						"& .MuiOutlinedInput-root": {
							"& fieldset": {
								borderBottomRightRadius: 0,
								borderTopRightRadius: 0,
							},
						},
					}}
					disabled={disabled}
					onChangeText={setNewCarPlate}
				/>
				<ButtonComponent
					disabled={disabled}
					sx={{
						borderBottomLeftRadius: 0,
						borderTopLeftRadius: 0,
						height: "70%",
					}}
					type="submit"
				>
					<Check />
				</ButtonComponent>
			</form>
			{getValues("carPlates") && getValues("carPlates")!.length > 0 && (
				<Grid2 size={12} sx={{ mb: 2 }}>
					<ChipListComponent
						chipIcon={<DirectionsCar />}
						chipData={getValues("carPlates") ?? []}
						onDelete={onDelete}
					/>
				</Grid2>
			)}
		</>
	);
};

export default CarPlate;
